import { useState } from "react"
import { hash } from "src/config";
import { useConfiguration } from "src/hooks/Configuration";
import { loadFromJson } from "src/utils/loadFromJson";

export default function useSpeakersHook(){

    const {configuration } = useConfiguration();

    const [speakers, setSpeakers] = useState<Array<any>>([]);

      const removerAcentos = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  };

  const orderList = (item) => {
    const valid = {
      asc: (speakers) => {
        if (speakers.length > 0) {
          speakers.sort((a, b) => {
            const nameA = removerAcentos(a.name)?.trim();
            const nameB = removerAcentos(b.name)?.trim();
            return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
          });
        }
        return speakers;
      },
      desc: (speakers) => {
        if (speakers.length > 0) {
          speakers.sort((a, b) => {
            const nameA = removerAcentos(a.name)?.trim();
            const nameB = removerAcentos(b.name)?.trim();
            return nameA < nameB ? 1 : nameA > nameB ? -1 : 0;
          });
        }
        return speakers;
      },
    };

    if (valid[item?.order_type]) {
      item.speakers = valid[item?.order_type](item?.speakers);
    }

    return item.speakers || [];
  };

    const loadSpeakers = async () => {

 const jsonData = await loadFromJson({ hash: hash, project_id: configuration?.url, table: 'SpeakerPosition' });

let data = jsonData || [];


    let newSpeakers: Array<any> = [];

        data.map((a: any) => {

          a.speakers = orderList(a);

          newSpeakers.push(a);



        })

        newSpeakers.sort((a, b) => {
          return parseInt(a.position, 10) > parseInt(b.position, 10) ? 1 : parseInt(a.position, 10) < parseInt(b.position, 10) ? -1 : 0
        })

         setSpeakers(newSpeakers);

    }

    return {
        speakers,
        loadSpeakers
    }
}